import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Link } from '@fluentui/react/lib/Link';
import { loading, isManualSearch } from 'owa-timestream-search-store';
import { openEditOutlookSpaceDialog } from 'owa-timestream-projectmanager';
import { noKeywordResultsDescription, clickToOpenSettings } from './NoResults.locstring.json';
import { noSearchResults } from 'owa-locstrings/lib/strings/nosearchresults.locstring.json';
import loc from 'owa-localize';
import showingResults from '../selectors/showingResults';

export default observer(function NoResults() {
    if (loading() || showingResults()) {
        return null;
    }

    return (
        <div className={styles.searchLabel}>
            {loc(noSearchResults)}
            <div className={styles.noResultsImage} />
            {!isManualSearch() && (
                <>
                    <div className={styles.noResultsDescription}>
                        {loc(noKeywordResultsDescription)}
                    </div>
                    <Link className={styles.linkToSettings} onClick={openEditSpaceDialog}>
                        {loc(clickToOpenSettings)}
                    </Link>
                </>
            )}
        </div>
    );
});

function openEditSpaceDialog(): void {
    openEditOutlookSpaceDialog('EmptyFRESearch');
}
